import React from 'react';
import PropTypes from 'prop-types';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMMessageFooterView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      reservation: this.props.reservation,
    };
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  showReservationView(e) {
    e.preventDefault();
    if (this.props.isOwner) {
      this.trackPageEvent('od reservation detail');
    }
    if(this.props.delegate && typeof this.props.delegate.showReservationView === 'function'){
      this.props.delegate.showReservationView();
    }
  }
  
  renderUser() {
    return null;
  }
  
  renderOwner() {
    return null;
  }
  
  render() {
    if (this.props.isOwner) {
      return this.renderOwner();
    } else {
      return this.renderUser();
    }
  }
}

SMMessageFooterView.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  reservation: PropTypes.object.isRequired,
};
export default SMMessageFooterView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageFooterView.jsx